import { render, staticRenderFns } from "./StoreSales.vue?vue&type=template&id=0652ffef"
import script from "./StoreSales.vue?vue&type=script&lang=js"
export * from "./StoreSales.vue?vue&type=script&lang=js"
import style0 from "./StoreSales.vue?vue&type=style&index=0&id=0652ffef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports